import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

// Token fallback for embedded previews where third-party cookies are blocked
export const tokens = {
  get access() { return localStorage.getItem("at_access"); },
  get refresh() { return localStorage.getItem("at_refresh"); },
  save(data) {
    if (data?.access_token) localStorage.setItem("at_access", data.access_token);
    if (data?.refresh_token) localStorage.setItem("at_refresh", data.refresh_token);
  },
  clear() {
    localStorage.removeItem("at_access");
    localStorage.removeItem("at_refresh");
  },
};

api.interceptors.request.use((cfg) => {
  const t = tokens.access;
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    const skip = ["/auth/refresh", "/auth/login", "/auth/register", "/auth/google/session"];
    if (err.response?.status === 401 && !cfg._retry && !skip.some((s) => cfg.url?.includes(s))) {
      cfg._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh", { refresh_token: tokens.refresh });
        const { data } = await refreshing;
        tokens.save(data);
        refreshing = null;
        return api(cfg);
      } catch (e) {
        refreshing = null;
      }
    }
    return Promise.reject(err);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Si è verificato un errore. Riprova.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (typeof d.msg === "string") return d.msg;
  return String(d);
}

export const STATUS = {
  in_coda: { label: "In coda", cls: "st-coda" },
  in_lavorazione: { label: "In lavorazione (Live)", cls: "st-live" },
  in_attesa: { label: "In attesa riscontro/dati", cls: "st-attesa" },
  completato: { label: "Completato/Risolto", cls: "st-done" },
};

export function waNumber(phone = "") {
  let d = String(phone).replace(/\D/g, "");
  if (d.startsWith("00")) d = d.slice(2);
  if (d.length === 10 && d.startsWith("3")) d = "39" + d;
  return d;
}

export const waLink = (phone, text) => `https://wa.me/${waNumber(phone)}?text=${encodeURIComponent(text)}`;
export const fileUrl = (id, download) => {
  const p = new URLSearchParams();
  if (download) p.set("download", "true");
  if (tokens.access) p.set("auth", tokens.access);
  const qs = p.toString();
  return `${API}/files/${id}${qs ? `?${qs}` : ""}`;
};
export const shareUrl = (token) => `${API}/share/${token}`;

export function fmtDate(ds, opts = { weekday: "long", day: "numeric", month: "long" }) {
  if (!ds) return "";
  const [y, m, d] = ds.split("-").map(Number);
  return new Date(y, m - 1, d).toLocaleDateString("it-IT", opts);
}

export function todayRome() {
  return new Date().toLocaleDateString("en-CA", { timeZone: "Europe/Rome" });
}

export function vehicleLabel(v = {}) {
  return [v.make, v.model].filter(Boolean).join(" ") || "Veicolo";
}

export const fmtSize = (b) => (b > 1048576 ? `${(b / 1048576).toFixed(1)} MB` : `${Math.max(1, Math.round(b / 1024))} KB`);
